import React from 'react';

import { useLang } from 'hooks';
import { useFilesQuery } from 'hooks/queries';
import { CardView } from 'components/layout';

import Item from './Item';

const ProfileVerification = () => {
  const lang = useLang();

  const filesQuery = useFilesQuery();

  const [idFile, selfieFile] = filesQuery.data ?? [];

  return (
    <CardView
      title={lang.get('profile.verification.title')}
      caption={lang.get('profile.verification.caption')}
    >
      <Item label={lang.get('common.form.idFile.label')} uploadedFile={idFile} />
      <Item label={lang.get('common.form.selfieFile.label')} uploadedFile={selfieFile} />
    </CardView>
  );
};

export default ProfileVerification;
